import React from 'react';
import { createRoot } from 'react-dom/client';
import PeopleArchive from './components/PeopleArchive';
import ProjectsArchive from './components/ProjectsArchive';
import BlogArchive from './components/BlogArchive';
import 'core-js/stable';

// ReplaceAll polyfill
if (!String.prototype.replaceAll) {
  String.prototype.replaceAll = function (str, newStr) {
    if (Object.prototype.toString.call(str).toLowerCase() === '[object regexp]') {
      return this.replace(str, newStr);
    }
    return this.replace(new RegExp(str, 'g'), newStr);
  };
}

// Dynamically mount React components using createRoot
const mountReactComponent = (Component, selector) => {
  const elements = document.querySelectorAll(selector);
  elements.forEach((el) => {
    const root = createRoot(el);
    root.render(<Component />);
  });
};

// Wait for DOMContentLoaded before mounting components
window.addEventListener('DOMContentLoaded', () => {
  mountReactComponent(PeopleArchive, '#vue-app people-archive'); // Mount PeopleArchive
  mountReactComponent(ProjectsArchive, '#vue-app projects-archive'); // Mount ProjectsArchive
  mountReactComponent(BlogArchive, '#vue-app blog-archive'); // Mount BlogArchive
});
